import React from 'react';

type Props = {
    id      : ID
    close   : callback
    fadeTime: number
}

export default class AutomationCreated extends React.Component<Props> {

    openAutomation = () => {
        gd.goTo('automation/{0}'.f(this.props.id))
        this.props.close();
    }

    copyLink = () => {
        const url = 'https://www.goodday.work/automation/{0}'.f(this.props.id);
        gd.utils.copyToClipboard(url);
        gd.growl.success("Link copied to clipboard");
        this.props.close();
    }

    render() {

        const classes = Classes("notification", "create", "h-60")

        return (
            <div className={classes} style={{transition: "opacity " + this.props.fadeTime + "s"}}>

                <div className="flex-row-left-top">
                    <div className="left-indicator h-60">
                        <div className="i5-done ui5-color-green fs-15 create-icon"/>
                    </div>
                    <div className="right-content">
                        <div className="ui5-txt-not-important-small m-b-8">Automation created</div>

                        {this.props.id && (
                            <div className="flex-row-between-center">
                                <div className="flex-row-left-center">
                                    <div className="flex-row-left-center link m-r-20" onClick={this.openAutomation}>
                                        <div className="i5-open-new-window m-r-5"></div>
                                        <div className="ui5-txt-link-tiny">Open</div>
                                    </div>

                                    <div className="flex-row-left-center link" onClick={this.copyLink}>
                                        <div className="i5-link m-r-5"></div>
                                        <div className="ui5-txt-link-tiny">Copy link</div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="close i5-delete" onClick={this.props.close}/>
            </div>
        )
    }
}
